<script lang="ts">
    import { createCheckbox, melt, createSync } from '@melt-ui/svelte';

    import { cx } from '$lib/utils/cx.js';

    let defaultClass: string = cx(
        'group',
        'force-size-[16px] shrink-0',
        'rounded-[2px]',
        'border-[1px] border-solid border-brand-blue',
        'aria-checked:bg-brand-blue',
        'flex items-center justify-center',
    );

    let className: string = '';
    export { className as class };

    export let defaultIconClass =
        'hidden group-aria-checked:block tnp tnp-check text-white text-10';
    export let iconClass = '';

    export let name: string;
    export let id: string;
    export let value: boolean = false;
    export let onChange: (newValue: boolean | 'indeterminate') => void;

    const {
        elements: { root, input },
        states: { checked },
    } = createCheckbox({
        name,
    });

    const sync = createSync({
        checked,
    });

    $: sync.checked(value, onChange);
</script>

<button use:melt={$root} class={cx(defaultClass, className)} id={`root-${id}`}>
    <i class={cx(defaultIconClass, iconClass)} aria-hidden={true} />
    <input use:melt={$input} {id} on:focus on:blur />
</button>
